(function () {
  const STAR = `<svg class="yk-reviews__star" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path fill="currentColor" d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>`;

  const THEMES = [
    { bg: '#fff', border: '#f0e6ec', star: '#f5b301', text: '#222', author: '#555', avatar: '#111', avatarText: '#fff' },
    { bg: '#fff', border: '#e8eaf6', star: '#f5b301', text: '#222', author: '#555', avatar: '#1a1a2e', avatarText: '#fff' },
    { bg: '#fff', border: '#e6f4ef', star: '#f5b301', text: '#222', author: '#555', avatar: '#0f4c3a', avatarText: '#fff' },
  ];

  function initials(name) {
    const parts = String(name || '').replace(/\./g, ' ').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return '?';
    if (/[\u0600-\u06FF]/.test(parts[0])) return parts[0].slice(0, 2);
    return (parts[0][0] + (parts[1]?.[0] || '')).toUpperCase();
  }

  function dedupe(reviews) {
    const seen = new Set();
    return reviews.filter((r) => {
      const key = `${r.name}|${r.text}`;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }

  function themeFor(review, index) {
    return THEMES[review.theme ?? index % THEMES.length];
  }

  function starsHtml() {
    return `<div class="yk-reviews__stars">${STAR.repeat(5)}</div>`;
  }

  function cardHtml(review, index) {
    const t = themeFor(review, index);
    const ini = review.initials || initials(review.name);
    return `
      <article class="yk-reviews__card" style="background:${t.bg};border-color:${t.border}">
        ${starsHtml()}
        <p class="yk-reviews__quote" style="color:${t.text}">${review.text}</p>
        <div class="yk-reviews__foot">
          <span class="yk-reviews__avatar" style="background:${t.avatar};color:${t.avatarText}">${ini}</span>
          <div class="yk-reviews__author">
            <span class="yk-reviews__name" style="color:${t.text}">${review.name}</span>
            <span class="yk-reviews__city" style="color:${t.author}">${review.city || ''}</span>
          </div>
          <span class="yk-reviews__verified">Verified</span>
        </div>
      </article>`;
  }

  function initSection(section) {
    const jsonEl = document.getElementById('yk-reviews-data');
    const track = section.querySelector('[data-yk-track]');
    const viewport = section.querySelector('[data-yk-viewport]');
    const prev = section.querySelector('[data-yk-prev]');
    const next = section.querySelector('[data-yk-next]');
    const dots = section.querySelector('[data-yk-dots]');

    let reviews = [];
    try {
      reviews = dedupe(JSON.parse(jsonEl?.textContent || '[]'));
    } catch (e) {
      reviews = [];
    }

    if (!reviews.length || !track) return;

    track.innerHTML = reviews.map((r, i) => cardHtml(r, i)).join('');

    const step = () => {
      const card = track.querySelector('.yk-reviews__card');
      return card ? card.offsetWidth + 20 : 360;
    };

    prev?.addEventListener('click', () => viewport.scrollBy({ left: -step(), behavior: 'smooth' }));
    next?.addEventListener('click', () => viewport.scrollBy({ left: step(), behavior: 'smooth' }));

    if (dots) {
      const pages = Math.ceil(reviews.length / 3);
      dots.innerHTML = Array.from({ length: Math.min(pages, 12) }, (_, i) =>
        `<button type="button" class="yk-reviews__dot${i === 0 ? ' is-active' : ''}" data-yk-dot="${i}" aria-label="Page ${i + 1}"></button>`
      ).join('');

      dots.querySelectorAll('[data-yk-dot]').forEach((dot) => {
        dot.addEventListener('click', () => {
          const i = Number(dot.dataset.ykDot);
          viewport.scrollTo({ left: step() * i * 3, behavior: 'smooth' });
        });
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-yk-reviews]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
